import { render } from "./ReservationCancellation.vue?vue&type=template&id=190e94fc"
import script from "./ReservationCancellation.vue?vue&type=script&lang=js"
export * from "./ReservationCancellation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__